"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _useClock2 = require("./useClock");
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _HitProvider = require("../provider/HitProvider");
var _timeBox = _interopRequireDefault(require("./timeBox"));
var __jsx = _react["default"].createElement;
var Clock = function Clock(_ref) {
  var _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel;
  var translations = {
    offerEnds: (0, _langLibrary["default"])("Offer ends"),
    offerStart: (0, _langLibrary["default"])("Offer start"),
    hours: (0, _langLibrary["default"])("hours hit"),
    minutes: (0, _langLibrary["default"])("minutes hit"),
    seconds: (0, _langLibrary["default"])("seconds hit")
  };
  var _useHit = (0, _HitProvider.useHit)(),
    isActive = _useHit.isActive;
  var _useClock = (0, _useClock2.useClock)(),
    hour = _useClock.hour,
    min = _useClock.min,
    sec = _useClock.sec;
  return __jsx(_react["default"].Fragment, null, showLabel ? __jsx(_Box["default"], {
    sx: {
      font: "base_sans_bold",
      color: "white",
      my: "s8"
    }
  }, isActive ? translations.offerEnds : translations.offerStart) : __jsx(_Box["default"], {
    sx: {
      height: 20
    }
  }), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      font: "sans_serif_40",
      color: "white",
      marginTop: "s6",
      px: 10
    }
  }, __jsx(_timeBox["default"], {
    numberOrText: hour
  }), __jsx(_timeBox["default"], {
    numberOrText: min
  }), __jsx(_timeBox["default"], {
    numberOrText: sec
  })), __jsx(_Box["default"], {
    sx: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      font: "xs_caps",
      fontSize: 12,
      color: "white",
      px: 10,
      mt: 10
    }
  }, __jsx(_timeBox["default"], {
    numberOrText: translations.hours,
    background: false
  }), __jsx(_timeBox["default"], {
    numberOrText: translations.minutes,
    background: false
  }), __jsx(_timeBox["default"], {
    numberOrText: translations.seconds,
    background: false
  })));
};
var _default = Clock;
exports["default"] = _default;